import { ReactNode } from 'react';

import { Box } from '../../../common/ui/Box';

interface QuickStatsWrapperProps {
    children: ReactNode;
}

export const QuickStatsWrapper = (props: QuickStatsWrapperProps) => {
    return (
        <Box paddingX={32} paddingY={24}>
            <Box display="flex" justifyContent="space-between" flexDirection="row">
                {props.children}
            </Box>
        </Box>
    );
};
